import React from 'react';
import { COLORS } from '@constants';
import { Col, Row } from 'antd';
import { StyledExampleImg, StyledText } from './styled';

const FourthRow = () => {
    return (
        <Row gutter={16}>
            <Col span={12}>
                <StyledExampleImg />
            </Col>
            <Col span={12}>
                <StyledText type='descriptor2' color={COLORS.$gray60Black}>
                    I authorize Klickly to debit my account for any and all fees incurred as a result of my use of the
                    Klickly Service and, if necessary, to credit my account to correct erroneous debits.
                </StyledText>
            </Col>
        </Row>
    );
};

export default FourthRow;
